import { InlineWidget } from "react-calendly";
import { useTranslation } from "../../i18n";

const CALENDLY_URL = "https://calendly.com/ben-muellerniklas/new-meeting";

const PARTNER_LOGOS = [
  ["oebb", "ÖBB"],
  ["fellbachgo", "Fellbach.go!"],
  ["koch-partner", "Koch & Partner"],
  ["allgaeutissimo", "Allgäutissimo Bikeshop"],
  ["velodepo", "VELODEPO"],
  ["opg", "OPG"],
  ["greenguard", "Greenguard"],
  ["emz", "emz"],
  ["hochschule-ansbach", "Hochschule Ansbach"],
  ["gablitz", "Gablitz"],
  ["mauerbach", "Mauerbach"],
  ["purkersdorf", "Stadtgemeinde Purkersdorf"],
  ["w5ww", "Wir 5 im Wienerwald"],
];

export default function NewMeetingRoute() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen overflow-x-hidden bg-white">
      <main>
        {/* ── Hero + scheduler ─────────────────────────────── */}
        <section className="relative overflow-hidden px-4 md:px-8 pt-32 pb-20">
          <div className="pointer-events-none absolute -top-40 -right-24 h-[460px] w-[460px] rounded-full bg-juhuu-glow blur-[90px]" />
          <div className="relative mx-auto grid max-w-7xl items-start gap-12 lg:grid-cols-2">
            {/* left — copy */}
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-juhuu-soft-2 bg-juhuu-soft px-3.5 py-1.5 text-sm font-bold text-juhuu-deep">
                <span className="h-[7px] w-[7px] rounded-full bg-juhuu" />
                {t("routes.meeting.badge")}
              </div>

              <h1 className="mt-5 text-[clamp(2.2rem,4vw,3.3rem)] font-extrabold leading-[1.02] tracking-[-0.035em] text-ink">
                {t("routes.meeting.heroTitleLine1")}
                <br />
                {t("routes.meeting.heroTitleLine2")}
              </h1>

              <p className="mt-5 max-w-[440px] text-[clamp(1.05rem,0.7vw+0.95rem,1.2rem)] font-medium leading-[1.65] text-muted">
                {t("routes.meeting.heroDescription")}
              </p>

              <div className="mt-8 flex flex-col gap-3">
                {[0, 1, 2].map((i) => (
                  <div key={i} className="flex items-start gap-2.5">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      className="mt-px h-5 w-5 flex-shrink-0 text-juhuu"
                    >
                      <path d="m5 12 5 5L20 7" />
                    </svg>
                    <span className="text-[.95rem] text-ink-2">
                      {t(`routes.meeting.bullets.${i}`)}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* right — Calendly inline scheduler */}
            <div className="overflow-hidden rounded-2xl border border-line bg-white p-2 shadow-sm">
              <InlineWidget
                url={CALENDLY_URL}
                styles={{ minWidth: 320, height: 700 }}
              />
            </div>
          </div>
        </section>

        {/* ── Trusted by ───────────────────────────────────── */}
        <section className="px-4 md:px-8 py-14">
          <div className="mx-auto max-w-7xl">
            <p className="mb-6 text-center text-[.82rem] font-bold uppercase tracking-[.14em] text-muted">
              {t("routes.meeting.trustedBy")}
            </p>
            <div className="w-full overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_10%,#000_90%,transparent)]">
              <div className="flex w-max animate-marquee items-center gap-[clamp(2rem,5vw,4rem)] hover:[animation-play-state:paused]">
                {[...PARTNER_LOGOS, ...PARTNER_LOGOS].map(([slug, name], i) => (
                  <span key={i} className="inline-flex flex-shrink-0">
                    <img
                      src={require(`../newApp/assets/logos/${slug}.png`)}
                      alt={name}
                      loading="lazy"
                      className="h-10 w-auto max-w-[170px] object-contain opacity-55 transition-opacity hover:opacity-100"
                    />
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
